'use strict';

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
},
    _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _withCommonProps = require('../withCommonProps'),
    _withCommonProps2 = _interopRequireDefault(_withCommonProps),
    _themes = require('../themes'),
    _propTypes3 = require('../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme),
    _Form = require('../Form'),
    _Form2 = _interopRequireDefault(_Form),
    _TextField = require('../TextField'),
    _TextField2 = _interopRequireDefault(_TextField),
    _Button = require('../Button'),
    _Button2 = _interopRequireDefault(_Button),
    _icons = require('../icons');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  div: {}
};
Styled.Form = (0, _styledComponents2.default)(_Form2.default).withConfig({
  displayName: 'SearchForm__Form'
})(['input[type=\'search\']{background-image:', ';', ';&[aria-invalid]{', ';background-image:', ';&:focus{background-image:', ';}}}&:focus-within input[type=\'search\']{outline:none;border-color:', ';box-shadow:', ';}'], (0, _themes.getStyle)('SearchFormInput_backgroundImage'), function (props) {
  return !props.sc.incremental && '\n        padding: 0 52px 0 12px;\n        background-position: right 52px top 8px;\n      ';
}, function (props) {
  var side = 'rtl' === props.theme.vstui.i18n.direction ? 'left' : 'right';
  return '\n          padding-' + side + ': ' + (props.sc.incremental ? 66 : 76) + 'px;\n        ';
}, (0, _themes.getStyle)('SearchFormInput_backgroundImage_invalid'), (0, _themes.getStyle)('SearchFormInput_backgroundImage_invalidFocus'), (0, _themes.getStyle)('SearchFormInputControl_borderColor_focus'), (0, _themes.getStyle)('SearchFormInputControl_boxShadow_focus')), Styled.div.wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'SearchForm__wrapper'
})(['position:relative;display:inline-block;width:', ';& > div{margin:0;}'], function (props) {
  return props.sc.fullWidth ? '100%' : 'auto';
}), Styled.Button = (0, _styledComponents2.default)(_Button2.default).withConfig({
  displayName: 'SearchForm__Button'
})(['position:absolute;top:0;right:0;']);

var SearchForm = function (_React$Component) {
  function SearchForm() {
    return _classCallCheck(this, SearchForm), _possibleConstructorReturn(this, (SearchForm.__proto__ || Object.getPrototypeOf(SearchForm)).apply(this, arguments));
  }

  return _inherits(SearchForm, _React$Component), _createClass(SearchForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          formProps = _props.formProps,
          fullWidth = _props.fullWidth,
          incremental = _props.incremental,
          placeholder = _props.placeholder,
          secondary = _props.secondary,
          size = _props.size,
          themeProp = _props.theme,
          otherProps = _objectWithoutProperties(_props, ['disabled', 'formProps', 'fullWidth', 'incremental', 'placeholder', 'secondary', 'size', 'theme']),
          theme = (0, _componentTheme2.default)(themeProp),
          label = 'Search' + (incremental ? ' (results update as you type)' : '');

      return _react2.default.createElement(Styled.Form, _extends({}, formProps, {
        sc: {
          incremental: incremental
        },
        theme: theme
      }), _react2.default.createElement(Styled.div.wrapper, {
        sc: {
          fullWidth: fullWidth
        }
      }, _react2.default.createElement(_TextField2.default, _extends({
        clearButtonDisabled: disabled || !incremental,
        disabled: disabled,
        fullWidth: fullWidth
      }, incremental ? {} : {
        icon: null
      }, {
        label: label,
        labelHidden: !0,
        placeholder: placeholder,
        secondary: secondary,
        size: size
      }, otherProps, {
        type: 'search'
      })), !incremental && _react2.default.createElement(Styled.Button, {
        disabled: disabled,
        iconStart: _react2.default.createElement(_icons.Search, null),
        label: 'Search',
        secondary: secondary,
        size: size,
        theme: theme
      })));
    }
  }]), SearchForm;
}(_react2.default.Component);

SearchForm.propTypes = {
  defaultValue: function defaultValue(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.value !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  },
  disabled: _propTypes2.default.bool,
  formProps: _propTypes2.default.object,
  fullWidth: _propTypes2.default.bool,
  incremental: _propTypes2.default.bool,
  nativeFormControlRef: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  theme: _propTypes3.themeShape,
  value: function value(props, propName, componentName) {
    if (props[propName] !== void 0) {
      if (props.defaultValue !== void 0) throw new Error('Props `defaultValue` and `value` are both defined in `' + componentName + '`, but only one is allowed. Use `defaultValue` for an uncontrolled component, or `value` for a controlled component.');
      if (void 0 === props.onChange) throw new Error('Please add prop `onChange` to `' + componentName + '`. Prop `value` has been set, which makes this a controlled component.');
      if ('string' != typeof props[propName] && 'number' != typeof props[propName] && null !== props[propName]) return new Error('Invalid prop `' + propName + '` of type `' + _typeof(props[propName]) + '` supplied to `' + componentName + '`, expected `string`, `number`, or a value of `null`.');
    }
  }
}, SearchForm.defaultProps = {
  incremental: !1,
  theme: (0, _themes.createTheme)()
}, SearchForm.displayName = 'SearchForm';
var SearchFormWithTheme = (0, _withCommonProps2.default)(SearchForm);
SearchFormWithTheme.WrappedComponent = SearchForm, exports.default = SearchFormWithTheme;